import { css } from '@emotion/core';
import { variables, media, tokens } from '@domain-group/fe-brary';
var font = variables.font;
var colors = tokens.colors;
export var dateSelector = /*#__PURE__*/css("font-size:", font.smallFontSize, ";margin-left:16px;white-space:nowrap;line-height:24px;", media('>=desktop'), "{font-size:", font.baseFontSize, ";}");
export var mobileButton = /*#__PURE__*/css("background:none;border:0;padding:0;margin-left:5px;outline:none;cursor:pointer;font-family:", font.bodyFontFamily, ";font-size:", font.smallFontSize, ";font-weight:", font.headingFontWeight, ";color:", colors.neutral.heavy.default, ";");

// FIXME: styles external components
export var options = /*#__PURE__*/css(".date-picker__container{position:static;margin-top:5px;", media('>=tablet'), "{position:absolute;margin-top:0;}}.react-datepicker__triangle{display:none;", media('>=tablet'), "{display:block;}}.text-input__icon-wrap.is-outside{display:inline-flex;height:30px;}.domain-radio__label{margin-bottom:-2px;}");
export var input = {
  name: "1j8r2w0",
  styles: "cursor:default;"
};
export var specificLabel = {
  name: "j4lo6u",
  styles: "line-height:30px;vertical-align:top;white-space:nowrap;margin-right:5px;"
};
export var specificWrapper = {
  name: "k008qs",
  styles: "display:flex;"
};
export var specificCal = /*#__PURE__*/css("margin-top:3px;color:", colors.neutral.subdued.default, ";");
export var arrowDownIcon = /*#__PURE__*/css("color:", colors.neutral.medium.default, ";");
export var mobileCalendarIcon = /*#__PURE__*/css("color:", colors.neutral.medium.default, ";");